export default function PhoneInput({ identifier, mandatory, onChange, value, disabled }) {
    const handleValueChange = (e) => {
        let input = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

        // Format the phone number
        if (input.length > 3 && input.length <= 6) {
            input = `(${input.slice(0, 3)}) ${input.slice(3)}`;
        } else if (input.length > 6) {
            input = `(${input.slice(0, 3)}) ${input.slice(3, 6)}-${input.slice(6, 10)}`;
        }

        // Update the value of the event object
        e.target.value = input;

        // Call the onChange handler passed from the context
        if (onChange) {
            onChange(e); // Pass the original event object
        }
    };

    return (
        <input
            type="tel"
            name={identifier}
            id={identifier}
            className={`tel-input default-input ${mandatory ? "mandatory-input" : ""}`}
            placeholder="(xxx) xxx-xxxx"
            maxLength={14}
            value={value || ""} // Use the value from the context
            onChange={handleValueChange} // Format and update the value
            required={mandatory}
        />
    );
}